// src/App.js
import React, { useState, useEffect } from "react";

import "./App.css"; // Ensure this is imported to apply the styles

import Approutes from "./routes";

const App = () => {
  return <Approutes />;
};

export default App;
